import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MyProfileScreen_Edit from '../screens/MyProfile/MyProfileScreen_Edit';
import MyProfileScreen_Photo from '../screens/MyProfile/MyProfileScreen_Photo';
import StartNetworking from '../screens/StartNetworking/StartNetworking';
import enrichmentRoutes from './enrichmentRoutes';

const startNetworkingRoutes = ({match}) => (
    <Switch>
        <Route path={`${match.path}/photo`} exact component={MyProfileScreen_Photo} />
        <Route path={`${match.path}/enrichments`} component={enrichmentRoutes} />
        <Route path={`${match.path}/bio`} component={MyProfileScreen_Edit} />
        <Route path={`${match.path}`} component={StartNetworking} />
    </Switch>
);

export default startNetworkingRoutes;
